module.exports = "/images/vendor/vue-paycard/src/12.jpg?690117a53d4ebf08dd0fb2242e8cb71b";